import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import PlanCard from "../components/subscription/PlanCard";
import CurrentPlan from "../components/subscription/CurrentPlan";
import { subscriptionService } from "../services/subscriptionService";

export default function SubscriptionPage() {
  const [plans, setPlans] = useState([]);
  const [current, setCurrent] = useState(null);
  const [pending, setPending] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [p, c] = await Promise.all([
        subscriptionService.listPlans(),
        subscriptionService.getCurrent(),
      ]);
      setPlans(p);
      setCurrent(c);
    } catch (err) {
      setPlans([]);
      setError(err?.message || "No se pudieron cargar los planes");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  async function subscribe(planId) {
    setPending(planId);
    try {
      await subscriptionService.subscribe(planId);
      await load();
      toast.success("Plan actualizado. (Stripe llegará muy pronto)");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setPending(null);
    }
  }

  return (
    <div className="px-5 pt-6 pb-10" data-testid="subscription-page">
      <div className="mx-auto max-w-4xl">
        <header className="mb-6">
          <p className="zx-label">Acceso</p>
          <h1 className="font-serif text-3xl tracking-tight md:text-4xl">
            Cortinas de seda
          </h1>
          <p className="mt-2 text-sm text-[rgba(255,255,255,0.65)]">
            Más discreción, más alcance. Elige hasta dónde quieres llegar.
          </p>
        </header>

        {loading ? (
          <p
            className="mt-10 text-center text-xs uppercase tracking-[0.2em] text-[rgba(255,255,255,0.45)]"
            data-testid="plans-loading"
          >
            Cargando planes...
          </p>
        ) : error ? (
          <div
            className="zx-card mt-8 flex flex-col items-center gap-4 p-8 text-center"
            data-testid="plans-error"
          >
            <p className="zx-label">Error</p>
            <p className="text-sm text-[rgba(255,255,255,0.7)]">{error}</p>
            <button
              type="button"
              onClick={load}
              className="rounded-full bg-[#8B1E3F] px-5 py-2 text-[10px] uppercase tracking-[0.22em] text-[#f5f5f5] hover:bg-[#B8325A]"
            >
              Reintentar
            </button>
          </div>
        ) : plans.length === 0 ? (
          <div className="zx-card mt-8 flex flex-col items-center gap-3 p-8 text-center" data-testid="plans-empty">
            <p className="zx-label">vacío</p>
            <h3 className="font-serif text-2xl">No hay planes disponibles</h3>
            <p className="text-sm text-[rgba(255,255,255,0.6)]">
              Vuelve más tarde o contacta con soporte si el problema persiste.
            </p>
          </div>
        ) : (
          <>
            {current && (
              <CurrentPlan
                plan={
                  plans.find((p) => p.id === current.currentPlanId) ??
                  (!current.subscribed ? plans.find((p) => p.price === 0) : null)
                }
                current={current}
              />
            )}

            <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3 zx-stagger" data-testid="plans-list">
              {plans.map((plan) => (
                <PlanCard
                  key={plan.id}
                  plan={plan}
                  active={current?.currentPlanId === plan.id}
                  loading={pending === plan.id}
                  onSelect={() => subscribe(plan.id)}
                />
              ))}
            </div>
          </>
        )}

        <p className="mt-8 text-center text-[10px] uppercase tracking-[0.22em] text-[rgba(255,255,255,0.4)]">
          Integración con Stripe — próximamente · pagos en modo prueba por ahora
        </p>
      </div>
    </div>
  );
}
